import { useState } from '#imports'

/**
 * Right-inset (px) reserved by the web shopping-assistant panel when it's
 * squeezing the layout (0 otherwise), shared across scopes so viewport-fixed
 * elements that the page's `margin-right` push can't reach (e.g. a
 * `position: fixed` `RevStickyBar`) can inset themselves to stay clear of the
 * panel instead of rendering underneath it.
 */
export const useShoppingAssistantSqueezeOffset = () => {
  const squeezeOffsetPx = useState('shopping-assistant-squeeze-offset', () => 0)

  function setSqueezeOffsetPx(offset: number) {
    squeezeOffsetPx.value = offset
  }

  return {
    squeezeOffsetPx,
    setSqueezeOffsetPx,
  }
}
